<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      width="440px"
      top="5vh"
      :title="editData && editData.html_no ? '修改广告页面' : '创建广告页面'"
      :close-on-click-modal="false"
      class="custom-dialog"
      :modal-append-to-body="false"
      @close="resetForm"
    >
      <!-- 区分A/B页面 -->
      <div style="margin-bottom: 10px; text-align: center">
        <el-radio-group v-model="distinguish" size="small">
          <el-radio-button :label="1">区分A/B页面</el-radio-button>
          <el-radio-button :label="2">只要B页面</el-radio-button>
        </el-radio-group>
      </div>

      <el-input
        v-model="remark"
        placeholder="请输入备注"
        size="medium"
        style="width: 100%; margin-bottom: 10px"
      />

      <el-tabs v-model="activeTab" stretch>
        <!-- A页面只有 distinguish=1 才会显示 -->
        <el-tab-pane v-if="distinguish === 1" label="A页面定制" name="real">
          <ad-content-form
            ref="realForm"
            v-model="realForm"
            :color-config="realColorConfig"
          />
        </el-tab-pane>
        <!-- B页面永远显示 -->
        <el-tab-pane
          :label="distinguish === 1 ? 'B页面定制' : '页面定制'"
          name="fake"
        >
          <ad-content-form
            ref="fakeForm"
            v-model="fakeForm"
            :color-config="fakeColorConfig"
          />
        </el-tab-pane>
      </el-tabs>

      <div>
        <div
          v-if="distinguish === 1"
          style="display: flex; gap: 10px; margin-bottom:12px; justify-content: center; flex-wrap: wrap"
        >
          <el-button
            icon="el-icon-view"
            style="width: 188px"
            @click="onPreview('real')"
          >预览A页面</el-button>
          <el-button
            icon="el-icon-view"
            style="width: 188px"
            @click="onPreview('fake')"
          >预览B页面</el-button>
        </div>
        <el-button
          v-else
          icon="el-icon-view"
          style="width:100%; margin-bottom:12px"
          @click="onPreview('fake')"
        >预览B页面</el-button>

        <el-button
          type="success"
          icon="el-icon-check"
          :loading="uploading"
          style="width: 100%; margin: 0px"
          @click="handleConfirm"
        >
          {{ editData && editData.html_no ? '保存并上传' : '确定并上传到腾讯云' }}
        </el-button>
      </div>

      <!-- 预览页面弹窗 -->
      <el-dialog
        title="预览页面"
        :visible.sync="previewVisible"
        width="90vw"
        top="5vh"
        :destroy-on-close="true"
        append-to-body
      >
        <iframe
          v-if="previewHtml"
          :srcdoc="previewHtml"
          style="width: 100%; height: 70vh; border: none; background: #f2f2f2"
        />
      </el-dialog>

      <!-- HTML代码查看弹窗 -->
      <el-dialog
        title="最终HTML代码（请复制后关闭）"
        :visible.sync="finalHtmlVisible"
        width="70vw"
        top="5vh"
        append-to-body
        :destroy-on-close="true"
      >
        <el-input
          v-model="finalHtml"
          type="textarea"
          rows="24"
          style="width: 100%; margin-bottom: 8px"
          readonly
        />
        <el-button
          type="primary"
          style="float: right"
          @click="copyFinalHtml"
        >复制代码</el-button>
      </el-dialog>
    </el-dialog>

    <!-- 上传进度 Timeline -->
    <el-dialog
      title="上传进度"
      :visible.sync="showUploadTimeline"
      append-to-body
    >
      <el-timeline>
        <el-timeline-item
          v-for="(step, idx) in timelineSteps"
          :key="idx"
          :color="step.success ? '#67C23A' : '#E6A23C'"
        >
          {{ step.text }}
        </el-timeline-item>
      </el-timeline>
    </el-dialog>
  </div>
</template>

<script>
import AdContentForm from './AdContentForm.vue'
import {
  createAdHtml,
  updateAdHtml,
  uoloadHtmlToTencent
} from '@/api/createDialog'
// import { getQcConfig } from '@/api/baiduAD.js'
// import { uploadHtmlToCos } from '@/utils/ObjectStorage.js'
import { uploadToTencentCloud } from '../../../utils/tencentUploader.js'
import { getQcDomains, getQcSingnedUrl } from '@/api/baiduAD.js'

export default {
  name: 'CreateDialog',
  components: { AdContentForm },
  props: {
    value: Boolean,
    editData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false,
      activeTab: 'fake',
      activeTabInited: false, // 标志位
      distinguish: 1, // 1=区分AB，2=只B页面
      realForm: this.getEmptyForm(),
      fakeForm: this.getEmptyForm(),
      realColorConfig: this.getDefaultColorConfig(),
      fakeColorConfig: this.getDefaultColorConfig(),
      previewVisible: false,
      previewHtml: '',
      finalHtmlVisible: false,
      finalHtml: '',
      config: {},
      uploading: false,
      showUploadTimeline: false,
      remark: '',
      domainDialogVisible: false, // 控制选择域名弹窗
      selectedDomain: '', // 用户选中的域名
      availableDomains: [], // 后端返回的域名列表
      timelineSteps: [], // 上传进度时间线
      selectedDomainId: null, // 选中ID
      selectedDomainObj: null // 存放完整配置对象
    }
  },
  watch: {
    value(val) {
      this.visible = val
    },
    visible(val) {
      this.$emit('input', val)
      if (val && this.editData && this.editData.html_no) {
      // 弹窗每次打开时才设置tab
        this.activeTab = this.distinguish === 2 ? 'fake' : 'real'
      }
      if (!val) this.resetForm()
    },
    distinguish(val) {
      // 当用户选择“只要B页面”时，让页面定制tab默认选中
      if (val === 2) {
        this.activeTab = 'fake'
      }
      // 当切回区分A/B页面时，默认显示A页面
      if (val === 1) {
        this.activeTab = 'real'
      }
    },
    editData: {
      handler(val, oldVal) {
        if (val && val.html_no) {
          this.distinguish = Number(val.distinguish)
          this.realForm = { ...this.getEmptyForm(), ...(val.realForm || {}) }
          this.realColorConfig = {
            ...this.getDefaultColorConfig(),
            ...(val.realColorConfig || {})
          }
          this.fakeForm = { ...this.getEmptyForm(), ...(val.fakeForm || {}) }
          this.fakeColorConfig = {
            ...this.getDefaultColorConfig(),
            ...(val.fakeColorConfig || {})
          }
          this.remark = val.remark || ''
        } else {
          this.resetForm()
        }
      },
      immediate: true
      // deep: true
    }

  },
  methods: {
    getEmptyForm() {
      return {
        adTitle: '',
        remark: '',
        banner: '',
        teacherAvatar: '',
        userAvatar: '',
        flows: [],
        ctaBtn: null
      }
    },
    getDefaultColorConfig() {
      return {
        questionColor: '#fff',
        answerColor: '#82E052',
        optionBtnColor: '#82E052',
        highlightKeywords: '',
        highlightColor: '#ff5000'
      }
    },
    resetForm() {
      this.activeTab = 'fake'
      this.distinguish = 1
      this.realForm = this.getEmptyForm()
      this.fakeForm = this.getEmptyForm()
      this.realColorConfig = this.getDefaultColorConfig()
      this.fakeColorConfig = this.getDefaultColorConfig()
      this.previewHtml = ''
      this.finalHtml = ''
      this.previewVisible = false
      this.finalHtmlVisible = false
      this.uploading = false
      this.remark = ''
    },
    copyFinalHtml() {
      if (!this.finalHtml) return
      navigator.clipboard
        .writeText(this.finalHtml)
        .then(() => {
          this.$message.success('已复制到剪贴板！')
          this.finalHtmlVisible = false
        })
        .catch(() => {
          this.$message.error('复制失败，请手动复制')
        })
    },
    onPreview(type) {
      let form, colorConfig
      if (type === 'real' && this.distinguish === 1) {
        form = this.realForm
        colorConfig = this.realColorConfig
      } else {
        form = this.fakeForm
        colorConfig = this.fakeColorConfig
      }
      if (!this.validate(form, colorConfig)) return
      this.previewHtml = this.buildSingleHtml(form, colorConfig)
      this.previewVisible = true
    },
    onSubmit() {
      if (this.distinguish === 1) {
        if (!this.validate(this.realForm, this.realColorConfig)) return
        if (!this.validate(this.fakeForm, this.fakeColorConfig)) return
        this.finalHtml = this.buildFinalHtml(
          this.realForm,
          this.fakeForm,
          this.realColorConfig,
          this.fakeColorConfig
        )
      } else {
        if (!this.validate(this.fakeForm, this.fakeColorConfig)) return
        this.finalHtml = this.buildSingleHtml(
          this.fakeForm,
          this.fakeColorConfig
        )
      }
      this.finalHtmlVisible = true
      this.previewVisible = false
    },

    // ✅ 上传入口（新版，无需弹窗选域名）
    async onUploadHtml() {
      let errors = []
      if (this.distinguish === 1) {
        errors = errors.concat(
          this.validate(this.realForm, this.realColorConfig, '页面A：')
        )
        errors = errors.concat(
          this.validate(this.fakeForm, this.fakeColorConfig, '页面B：')
        )
      } else {
        errors = errors.concat(
          this.validate(this.fakeForm, this.fakeColorConfig, '页面B：')
        )
      }
      if (!this.remark) errors.push('备注不能为空')
      if (errors.length) {
        this.$alert(errors.join('\n'), '校验不通过', { type: 'warning' })
        return
      }

      try {
        // 🔹 获取可选域名列表
        const domainRes = await getQcDomains({ type: 1 })
        const list = domainRes?.data?.list || []
        if (!list.length) {
          this.$message.error('未获取到可用域名')
          return
        }

        // 🔸 直接取第一个域名
        this.selectedDomainObj = {
          domain: list[0].config?.domain,
          bucket: list[0].config?.bucket
        }

        // 🔸 立即开始上传流程
        await this.startUploadProcess()
      } catch (err) {
        this.$message.error('获取域名失败：' + (err.message || err))
      }
    },

    // ✅ 核心上传流程（修改参数结构）
    async startUploadProcess() {
      this.timelineSteps = []
      this.uploading = true
      this.showUploadTimeline = true

      try {
        const { domain } = this.selectedDomainObj

        // 🟢 1️⃣ 上传图片资源
        this.timelineSteps.push({ text: '开始上传图片资源...', success: false })
        const allImages = this.collectAllImages()

        for (const item of allImages) {
          if (typeof item.file === 'string' && item.file.startsWith('http')) {
            this.timelineSteps.push({ text: `${item.field} 已是线上URL，跳过`, success: true })
            continue
          }

          // 🔹 新版参数
          const fileName = `${Date.now()}_${Math.random().toString(36).slice(2)}.png`
          const { data } = await getQcSingnedUrl({
            type: 1,
            path: 'h5/images/',
            file_name: fileName
          })

          const signedUrl = data?.signed_url
          if (!signedUrl) throw new Error(`未获取到上传签名URL: ${item.field}`)

          const fileBlob = await fetch(item.file).then(r => r.blob())
          await uploadToTencentCloud(fileBlob, signedUrl, fileBlob.type)

          const finalUrl = `${domain.replace(/\/$/, '')}/h5/images/${fileName}`
          this.replaceFormImage(item.field, finalUrl)
          this.timelineSteps.push({ text: `${item.field} 上传成功 ✅`, success: true })
        }
        this.timelineSteps.push({ text: '图片上传完成 ✅', success: true })

        // 🟢 2️⃣ 构建 HTML
        this.timelineSteps.push({ text: '构建HTML中...', success: false })
        const finalHtml =
      this.distinguish === 1
        ? this.buildFinalHtml(
          this.realForm,
          this.fakeForm,
          this.realColorConfig,
          this.fakeColorConfig
        )
        : this.buildSingleHtml(this.fakeForm, this.fakeColorConfig)
        this.timelineSteps.push({ text: 'HTML 构建完成 ✅', success: true })

        // 🟢 3️⃣ 创建/更新广告
        this.timelineSteps.push({ text: '同步广告信息到后端...', success: false })
        const params = {
          title: this.realForm.adTitle || this.fakeForm.adTitle || '',
          remark: this.remark,
          distinguish: this.distinguish,
          html_text:
        this.distinguish === 1
          ? JSON.stringify({ ...this.realForm, colorConfig: this.realColorConfig })
          : '',
          ad_title: this.fakeForm.adTitle || '',
          ad_html_text: JSON.stringify({
            ...this.fakeForm,
            colorConfig: this.fakeColorConfig
          })
        }

        let htmlNo = ''
        let uploadUrl = ''

        if (this.editData?.html_no) {
          const res = await updateAdHtml({ html_no: this.editData.html_no, ...params })
          htmlNo = this.editData.html_no
          uploadUrl = res?.data?.upload_url
          this.timelineSteps.push({ text: `广告更新成功 (html_no: ${htmlNo})`, success: true })
        } else {
          const res = await createAdHtml(params)
          htmlNo = res?.data?.html_no
          uploadUrl = res?.data?.upload_url
          console.log(uploadUrl)
          this.timelineSteps.push({ text: `广告创建成功 (html_no: ${htmlNo})`, success: true })
        }
        const uploadPath = uploadUrl.substring(0, uploadUrl.lastIndexOf('/') + 1)

        if (!htmlNo || !uploadUrl) throw new Error('后端未返回 html_no 或 upload_url')

        // 🟢 4️⃣ 获取 HTML 上传签名
        this.timelineSteps.push({ text: '获取HTML上传签名...', success: false })
        const { data: htmlSignData } = await getQcSingnedUrl({
          type: 1,
          path: uploadPath,
          file_name: `${htmlNo}.html`
        })
        const htmlSignedUrl = htmlSignData?.signed_url
        if (!htmlSignedUrl) throw new Error('未获取到HTML上传签名')
        this.timelineSteps.push({ text: 'HTML签名获取成功 ✅', success: true })

        // 🟢 5️⃣ 上传 HTML 文件
        const htmlBlob = new Blob([finalHtml], { type: 'text/html' })
        await uploadToTencentCloud(htmlBlob, htmlSignedUrl, 'text/html')
        this.timelineSteps.push({ text: 'HTML 文件上传成功 ✅', success: true })

        // 🟢 6️⃣ 通知腾讯同步
        this.timelineSteps.push({ text: '通知腾讯同步中...', success: false })
        await uoloadHtmlToTencent({ html_no: htmlNo })
        this.timelineSteps.push({ text: '同步完成 ✅', success: true })

        this.$message.success('上传成功!')
        this.timelineSteps.push({ text: '创建流程已全部完成 🎉', success: true })

        setTimeout(() => {
          this.visible = false
          this.processDialogVisible = false
          this.uploadDialogVisible = false
          this.showUploadTimeline = false
          this.$emit('success')
        }, 800)
      } catch (err) {
        console.error(err)
        this.timelineSteps.push({ text: `上传失败：${err.message}`, success: false })
        this.timelineSteps.push({ text: '关闭弹窗当前重新再提交', success: false })
        this.$message.error(`上传失败：${err.message}`)
      } finally {
        this.uploading = false
      }
    },

    // 负责先验证，再上传
    async handleConfirm() {
      // 先执行校验逻辑
      let errors = []
      if (this.distinguish === 1) {
        errors = errors.concat(
          this.validate(this.realForm, this.realColorConfig, '页面A：')
        )
        errors = errors.concat(
          this.validate(this.fakeForm, this.fakeColorConfig, '页面B：')
        )
      } else {
        errors = errors.concat(
          this.validate(this.fakeForm, this.fakeColorConfig, '页面B：')
        )
      }

      if (!this.remark) errors.push('备注不能为空')

      if (errors.length) {
        this.$alert(errors.join('\n'), '校验不通过', { type: 'warning' })
        return
      }

      // ✅ 只有校验通过时才执行上传逻辑
      await this.onUploadHtml()
    },

    // ✅ 用户选择域名
    async confirmDomainSelection() {
      const domainObj = this.availableDomains.find(d => String(d.id) === String(this.selectedDomainId))

      if (!domainObj) {
        this.$message.warning('请选择一个域名')
        return
      }
      this.selectedDomainObj = domainObj
      this.domainDialogVisible = false
      await this.startUploadProcess()
    },

    collectAllImages() {
      return [
        { field: 'realForm.banner', file: this.realForm.banner },
        { field: 'realForm.teacherAvatar', file: this.realForm.teacherAvatar },
        { field: 'realForm.userAvatar', file: this.realForm.userAvatar },
        { field: 'fakeForm.banner', file: this.fakeForm.banner },
        { field: 'fakeForm.teacherAvatar', file: this.fakeForm.teacherAvatar },
        { field: 'fakeForm.userAvatar', file: this.fakeForm.userAvatar }
      ].filter(i => i.file)
    },

    replaceFormImage(field, newUrl) {
      if (field.startsWith('realForm')) {
        const key = field.replace('realForm.', '')
        this.realForm[key] = newUrl
      } else if (field.startsWith('fakeForm')) {
        const key = field.replace('fakeForm.', '')
        this.fakeForm[key] = newUrl
      }
    },

    // ⭐️ flows 预处理
    preprocessFlows(flows) {
      return (flows || []).map(msg => {
        if (msg.type === 'answer') {
          const newOpts = (msg.options || []).map(opt => {
            const base = typeof opt === 'string'
              ? { text: opt, link: '', linkList: [], bMsg: '', continueFlow: true }
              : { continueFlow: true, linkList: [], ...opt }
            const list = Array.isArray(base.linkList)
              ? base.linkList
                .map(item => (item && item.url ? String(item.url).trim() : ''))
                .filter(Boolean)
                .map(url => ({ url }))
              : []
            if (!list.length && base.link) {
              list.push({ url: String(base.link).trim() })
            }
            return { ...base, linkList: list }
          })
          return { ...msg, options: newOpts }
        }
        return msg
      })
    },

    buildSingleHtml(form, colorConfig) {
      const { adTitle, banner } = form
      const flows = this.preprocessFlows(form.flows || [])
      const { headContent, scriptContent } = this.buildHtmlAssets(
        { ...form, flows }, colorConfig
      )
      // 如果是按钮模式，直接生成极简结构
      if (form.ctaBtn) {
        // 合理处理用户可能输入的各种单位
        const width = form.ctaBtn.width ? (isNaN(Number(form.ctaBtn.width)) ? form.ctaBtn.width : form.ctaBtn.width + 'px') : '220px'
        const height = form.ctaBtn.height ? (isNaN(Number(form.ctaBtn.height)) ? form.ctaBtn.height : form.ctaBtn.height + 'px') : '48px'
        const radius = form.ctaBtn.radius ? (isNaN(Number(form.ctaBtn.radius)) ? form.ctaBtn.radius : form.ctaBtn.radius + 'px') : '30px'
        const color = form.ctaBtn.color || '#4CC40F'
        console.log(width, height, radius, color)
        return `
        <!DOCTYPE html>
        <html lang="zh">
        <head>
          <meta charset="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <title>${form.adTitle || ''}</title>
          <style>
            body { margin:0; background:#f2f2f2; }
            .container { max-width:430px; margin:0 auto; padding:40px 0; text-align:center; }
            .banner { width:100%; border-radius:10px; }
            .cta-btn { 
              margin-top:34px; 
              padding:0; 
              background:${form.ctaBtn.color || '#4CC40F'}; 
              border:none !important; 
              border-radius:${form.ctaBtn.radius ? (isNaN(Number(form.ctaBtn.radius)) ? form.ctaBtn.radius : form.ctaBtn.radius + 'px') : '30px'};
              font-size:1.18em; color:#fff; font-weight:bold; cursor:pointer;
              width:${form.ctaBtn.width ? (isNaN(Number(form.ctaBtn.width)) ? form.ctaBtn.width : form.ctaBtn.width + 'px') : '220px'};
              height:${form.ctaBtn.height ? (isNaN(Number(form.ctaBtn.height)) ? form.ctaBtn.height : form.ctaBtn.height + 'px') : '48px'};
              line-height:${form.ctaBtn.height ? (isNaN(Number(form.ctaBtn.height)) ? form.ctaBtn.height : form.ctaBtn.height + 'px') : '48px'};
              transition: background .2s;
            }
            .cta-btn:active { opacity: 0.9; }
          </style>
        </head>
        <body>
          <div class="container">
            <img class="banner" src="${form.banner}" alt="banner" />
            <button class="cta-btn" id="myBtn" style="margin-top:3vw;">${form.ctaBtn.text || '按钮'}</button>
          </div>
          <script>
            window.realConfig = ${JSON.stringify(form)};
            window.fakeConfig = ${JSON.stringify(form.fakeConfig || form)};
            function getUrlParam(keys) {
              const params = new URLSearchParams(window.location.search);
              let hasValid = false;

              for (let i = 0; i < keys.length; i++) {
                const val = params.get(keys[i]);
                if (val) {
                  if (val.includes('1888888887')) {
                    return false;
                  } else {
                    hasValid = true; 
                  }
                }
              }

              return hasValid; 
            }
            var config = ${
  form.distinguish === 1
    ? "getUrlParam(['advertiser_id','gdt_vid','qz_gdtid','wx_aid','gdt_vid','wx_traceid','weixinadinfo','traceid','aid','uxinfo']) ? window.fakeConfig : window.realConfig"
    : 'window.fakeConfig'
}

            if (config && config.adTitle) {
              document.title = config.adTitle;
            }

        
          var btn = document.getElementById('myBtn');
          if (btn && config.ctaBtn && config.ctaBtn.link) {
            btn.onclick = function () {
              window.location.href = config.ctaBtn.link;
            };
          }

          const selections = []; 
          function recordSelection(questionText, btnText) {
            if (!questionText) return;
            const i = selections.findIndex(([k]) => k === questionText);
            if (i >= 0) selections[i][1] = btnText || '';
            else selections.push([questionText, btnText || '']);
          }

          function buildQAString() {
            return selections
              .map(function (pair) { return pair[0] + ':' + pair[1]; })
              .join(',');
          }

          function extractHtmlNo() {
            var m = (window.location.href.match(/(HL[0-9A-Za-z]+)\.html/i) || [])[1];
            return m || '';
          }

          async function go(link) {
            let id = '';
            try {
              const qa = buildQAString();      // 拼接问答内容
              const htmlNo = extractHtmlNo();  // 提取 html_no

              const res = await fetch(' https://operation.jingxuanhz.com/ad/qaParameters', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  qa_content: qa,
                  html_no: htmlNo
                })
              });

              if (res && res.ok) {
                let data = {};
                try {
                  data = await res.json();
                } catch (_) {}
                id = (data && (data.id || (data.data && data.data.id))) || '';
              }
            } catch (e) {
              console.error('埋点请求失败:', e);
            }

            // 🔑 确保无论请求成功/失败，都在这里再执行跳转
            try {
              let url = new URL(link, window.location.href);
              if (id) {
                url.searchParams.set('customer_channel', String(id));
              }
              window.location.href = url.toString();
            } catch (_) {
              if (id) {
                let sep = link.indexOf('?') >= 0 ? '&' : '?';
                window.location.href = link + sep + 'customer_channel=' + encodeURIComponent(id);
              } else {
                window.location.href = link;
              }
            }
          }



            var btn = document.getElementById('myBtn');
            if (btn && config.ctaBtn) {
              btn.style.background = config.ctaBtn.color || '#4CC40F';
              btn.style.width = config.ctaBtn.width ? (isNaN(Number(config.ctaBtn.width)) ? config.ctaBtn.width : config.ctaBtn.width + 'px') : '220px';
              btn.style.height = config.ctaBtn.height ? (isNaN(Number(config.ctaBtn.height)) ? config.ctaBtn.height : config.ctaBtn.height + 'px') : '48px';
              btn.style.lineHeight = config.ctaBtn.height ? (isNaN(Number(config.ctaBtn.height)) ? config.ctaBtn.height : config.ctaBtn.height + 'px') : '48px';
              btn.style.borderRadius = config.ctaBtn.radius ? (isNaN(Number(config.ctaBtn.radius)) ? config.ctaBtn.radius : config.ctaBtn.radius + 'px') : '30px';
            }

            
          <\/script>
        </body>
        </html>
      `
      }

      return `<!DOCTYPE html>
        <html lang="zh">
        <head>
          <meta charset="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <title>${adTitle || ''}</title>
          ${headContent}
        </head>
        <body>
          <div id="app">
            <div class="container">
              <img class="banner" src="${banner}" alt="banner">
              <div class="chat-area" id="chatArea"></div>
              <div class="bottom-bar"></div>
            </div>
          </div>
          ${scriptContent}
        </body>
        </html>`
    },

    buildFinalHtml(realForm, fakeForm, realColor, fakeColor) {
      // flows 处理
      const realConfig = this.packConfig({ ...realForm, flows: this.preprocessFlows(realForm.flows || []) }, realColor)
      const fakeConfig = this.packConfig({ ...fakeForm, flows: this.preprocessFlows(fakeForm.flows || []) }, fakeColor)
      const headContent = this.buildHtmlAssets({ ...realForm, flows: this.preprocessFlows(realForm.flows || []) }, realColor).headContent

      function getKeywordReg(config) {
        const arr = (config.highlightKeywords || '')
          .split(/,|，/)
          .map(k => k.trim())
          .filter(Boolean)
        if (!arr.length) return ''
        return (
          '(' +
      arr.map((k) => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|') +
      ')'
        )
      }
      const keywordReg = getKeywordReg(realConfig)
      const highlightFn = keywordReg
        ? `function highlightTeacher(str) {
            return str.replace(/${keywordReg}/g, '<span class="keyword">$1</span>').replace(/(\\d+)/g, '<span class="number">$1</span>');
          }`
        : `function highlightTeacher(str) {
            return str.replace(/(\\d+)/g, '<span class="number">$1</span>');
          }`

      return `<!DOCTYPE html>
        <html lang="zh">
        <head>
            <meta charset="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <title>${realConfig.adTitle || ''}</title>
            ${headContent}
        </head>
        <body>
            <div id="app">
            <div class="container">
                <img class="banner" id="bannerImg" src="" alt="banner">
                <button class="cta-btn" id="myBtn" style="display:none;margin-top:3vw;">按钮</button>
                <div class="chat-area" id="chatArea"></div>
                <div class="bottom-bar"></div>
            </div>
            </div>
            <script>
              window.realConfig = ${JSON.stringify(realConfig)};
              window.fakeConfig = ${JSON.stringify(fakeConfig)};
              function getUrlParam(keys) {
                const params = new URLSearchParams(window.location.search);
                let hasValid = false;

                for (let i = 0; i < keys.length; i++) {
                  const val = params.get(keys[i]);
                  if (val) {
                    if (val.includes('1888888887')) {
                      return false;
                    } else {
                      hasValid = true; 
                    }
                  }
                }

                return hasValid; 
              }
              var config = ${
  this.distinguish === 1
    ? "getUrlParam(['advertiser_id','gdt_vid','qz_gdtid','wx_aid','gdt_vid','wx_traceid','weixinadinfo','traceid','aid','uxinfo']) ? window.fakeConfig : window.realConfig"
    : 'window.fakeConfig'
};

        ${highlightFn}

        const teacherAvatar = config.teacherAvatar || "";
        const userAvatar = config.userAvatar || "";

        const steps = [];
        let lastQuestionText = '';

        (config.flows || []).forEach((msg, i, flows) => {
          if (msg.type === 'info') {
            steps.push({ type: 'msg', sender: 'teacher', content: msg.content });
          } else if (msg.type === 'question') {
            steps.push({ type: 'msg', sender: 'teacher', content: msg.content });
            lastQuestionText = msg.content || '';
            const answerMsg = flows[i + 1];
            if (answerMsg && answerMsg.type === 'answer') {
              steps.push({
                type: 'choice',
                options: answerMsg.options,  // ✅ 每个选项: { text, link, bMsg }
                questionText: lastQuestionText
              });
            }
          }
        });

        if (config && config.adTitle) {
          document.title = config.adTitle;
        }

        let currentStep = 0;
        function pushMessage(sender, content) {
          const area = document.getElementById('chatArea');
          const msgWrap = document.createElement('div');
          msgWrap.className = 'chat-item' + (sender === 'user' ? ' user' : '');
          const avatar = document.createElement('img');
          avatar.className = 'chat-avatar' + (sender === 'user' ? ' user' : '');
          avatar.src = sender === 'teacher' ? teacherAvatar : userAvatar;
          msgWrap.appendChild(avatar);
          const msg = document.createElement('div');
          msg.className = 'chat-msg' + (sender === 'user' ? ' user' : '');
          msg.innerHTML = sender === 'teacher' ? highlightTeacher(content) : content;
          msgWrap.appendChild(msg);
          area.appendChild(msgWrap);
          area.scrollTop = area.scrollHeight;
        }
        
        const selections = [];
        
        function recordSelection(questionText, btnText) {
          if (!questionText) return;
          const i = selections.findIndex(([k]) => k === questionText);
          if (i >= 0) selections[i][1] = btnText || '';
          else selections.push([questionText, btnText || '']);
        }

        function renderOptions(options, questionText) {
          const bar = document.querySelector('.bottom-bar');
          bar.innerHTML = '';  
          
          const row = document.createElement('div');
          row.className = 'btn-row'; 
          
          options.forEach((opt) => {
            const btn = document.createElement('button');
            btn.className = 'btn-main';
            btn.textContent = opt.text || ''; 
            
            btn.onclick = async () => {
              disableButtons();
              recordSelection(questionText || '', opt.text || '');
              pushMessage('user', opt.text || '');

              const linkList = Array.isArray(opt.linkList)
                ? opt.linkList.map(item => item && item.url).filter(Boolean)
                : [];
              const finalLink = linkList.length
                ? linkList[Math.floor(Math.random() * linkList.length)]
                : opt.link;

              if (finalLink) {
                if (opt.bMsg) {
                  setTimeout(() => pushMessage('teacher', opt.bMsg), 500);
                }
                window.location.href = finalLink;
                return;
              }

              if (opt.continueFlow !== false) {
                setTimeout(showNext, 600);
              }
            };
            
            row.appendChild(btn); 
          });
          
          bar.appendChild(row); 
        }

        function disableButtons() {
          const buttons = document.querySelectorAll('.btn-main');
          buttons.forEach(btn => {
            btn.disabled = true;
          });
        }

        function buildQAString() {
          return selections
            .map(function (pair) { return pair[0] + ':' + pair[1]; })
            .join(',');
        }

        function extractHtmlNo() {
          var m = (window.location.href.match(/(HL[0-9A-Za-z]+)\.html/i) || [])[1];
          return m || '';
        }

        async function go(link) {
          let id = '';
          try {
            const qa = buildQAString();      
            const htmlNo = extractHtmlNo();  

            const res = await fetch('https://operation.jingxuanhz.com/ad/qaParameters', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                qa_content: qa,
                html_no: htmlNo
              })
            });

            if (res && res.ok) {
              let data = {};
              try {
                data = await res.json();
              } catch (_) {}
              id = (data && (data.id || (data.data && data.data.id))) || '';
            }
          } catch (e) {
            console.error('埋点请求失败:', e);
          }

          try {
            let url = new URL(link, window.location.href);
            if (id) {
              url.searchParams.set('customer_channel', String(id));
            }
            window.location.href = url.toString();
          } catch (_) {
            if (id) {
              let sep = link.indexOf('?') >= 0 ? '&' : '?';
              window.location.href = link + sep + 'customer_channel=' + encodeURIComponent(id);
            } else {
              window.location.href = link;
            }
          }
        }

        function showAllMsgUntilChoice(cb) {
          if (currentStep >= steps.length) return;
          const step = steps[currentStep];
          if (step.type === 'msg') {
              pushMessage('teacher', step.content);
              currentStep++;
              setTimeout(() => showAllMsgUntilChoice(cb), 500);
          } else if (step.type === 'choice') {
              if (cb) cb(step);
          }
        }

        function showNext() {
          if (currentStep >= steps.length) return;
          const step = steps[currentStep];
          if (step.type === 'msg') {
              pushMessage('teacher', step.content);
              currentStep++;
              setTimeout(showNext, 500);
          } else if (step.type === 'choice') {
              renderOptions(step.options, step.questionText);
              currentStep++;
            }
        }

        document.addEventListener('DOMContentLoaded', () => {
          document.getElementById('bannerImg').src = config.banner;
          var btn = document.getElementById('myBtn');
          var chatArea = document.getElementById('chatArea');
          var bottomBar = document.querySelector('.bottom-bar');
          if (config.ctaBtn) {
            btn.style.display = '';
            btn.textContent = config.ctaBtn.text || '按钮';
            btn.onclick = async function() {
              if (config.ctaBtn && config.ctaBtn.link) {
                await go(config.ctaBtn.link);
              }
            };

            btn.style.background = config.ctaBtn.color || '#4CC40F';
            btn.style.width = config.ctaBtn.width ? (isNaN(Number(config.ctaBtn.width)) ? config.ctaBtn.width : config.ctaBtn.width + 'px') : '220px';
            btn.style.height = config.ctaBtn.height ? (isNaN(Number(config.ctaBtn.height)) ? config.ctaBtn.height : config.ctaBtn.height + 'px') : '48px';
            btn.style.lineHeight = btn.style.height;
            btn.style.borderRadius = config.ctaBtn.radius ? (isNaN(Number(config.ctaBtn.radius)) ? config.ctaBtn.radius : config.ctaBtn.radius + 'px') : '30px';
            chatArea.style.display = 'none';
            btn.style.border = 'none';
            btn.style.margin = '0 auto';
            btn.style.color = '#fff';
            bottomBar.style.display = 'none';
          } else {
            btn.style.display = 'none';
            chatArea.style.display = '';
            bottomBar.style.display = '';
            showAllMsgUntilChoice((choiceStep) => {
              renderOptions(choiceStep.options, choiceStep.questionText);
              currentStep++;
            });
          }
        });
      <\/script>
  </body>
  </html>`
    },

    packConfig(form, colorConfig) {
      const { remark, ...formRest } = form || {}
      console.log(remark)
      return Object.assign({}, formRest, colorConfig)
    },

    buildHtmlAssets(form, colorConfig) {
      // 用预处理 flows
      const flows = this.preprocessFlows(form.flows || [])
      // 1. 生成 steps
      const steps = []
      let lastQuestionText = ''

      flows.forEach((msg, i) => {
        if (msg.type === 'info') {
          steps.push({ type: 'msg', sender: 'teacher', content: msg.content })
        } else if (msg.type === 'question') {
          steps.push({ type: 'msg', sender: 'teacher', content: msg.content })
          lastQuestionText = msg.content || ''
          const answerMsg = flows[i + 1]
          if (answerMsg && answerMsg.type === 'answer') {
            steps.push({
              type: 'choice',
              options: answerMsg.options, // ✅ 这里是对象数组
              isEnd: !!answerMsg.isEnd,
              endLink: answerMsg.endLink || '',
              bMsg: answerMsg.bMsg || '',
              questionText: lastQuestionText
            })
          }
        }
      })

      // 关键词处理
      const keywordsArr = colorConfig.highlightKeywords
        ? colorConfig.highlightKeywords
          .split(/,|，/)
          .map((x) => x.trim())
          .filter(Boolean)
        : []
      const keywordReg =
    keywordsArr.length > 0
      ? '(' +
        keywordsArr
          .map((k) => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
          .join('|') +
        ')'
      : ''
      // 颜色
      const questionColor = colorConfig.questionColor
      const answerColor = colorConfig.answerColor
      const optionBtnColor = colorConfig.optionBtnColor
      const highlightColor = colorConfig.highlightColor
      // 样式
      const headContent = `
      <style>
      body, html { margin: 0; padding: 0; height: 100%; }
      #app { height: 100%; }
      .container { max-width: 430px; height: 100%; margin: 0 auto; display: flex; flex-direction: column; background: #f2f2f2; box-shadow: 0 2px 16px #0001; }
      .banner { flex-shrink: 0; width: 100%; border-radius: 0 0 20px 20px; display: block; height: 45%; }
      .chat-area { height: 50%; flex: 1; scroll-behavior: smooth; scroll-snap-type: y proximity; overflow-y: auto; padding: 25px 10px; box-sizing: border-box; }
      .chat-area::-webkit-scrollbar { width: 0; height: 0; background: transparent; }
      @media (pointer: coarse) { .chat-area { -webkit-overflow-scrolling: touch; } }
      .chat-item { display: flex; align-items: flex-start; margin-bottom: 20px; animation: fadeInUp .6s; }
      .chat-item.user { flex-direction: row-reverse; }
      @keyframes fadeInUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
      .chat-avatar { width: 36px; height: 36px; border-radius: 50%; object-fit: cover; border: 2px solid #fff; box-shadow: 0 1px 4px #d4e2d5; background: #eee; margin-right: 12px; }
      .chat-avatar.user { margin-left: 12px; margin-right: 0; }
      .keyword, .number { color: ${highlightColor} !important; font-weight: 600; }
      .bottom-bar { height: 10%; padding: 14px 10px; flex-shrink: 0; display: flex; align-items: flex-end; background-color: #ffffff00; }
      .bottom-bar>button.btn-main { width: 80%; height: 50px; max-width: 300px; line-height: 26px; margin: 0 auto 12px; display: block; }
      .btn-row { width: 100%; display: flex; gap: 12px; flex-wrap: wrap; justify-content: center }
      .btn-row .btn-main { margin: 0; width: 45%; height: 50px; line-height: 17px; }
      .btn-main {
        background: ${optionBtnColor} !important;
        width: 90%;
        padding: 13px 0;
        color: #fff;
        border: none;
        border-radius: 50px;
        font-size: 1.12rem;
        font-weight: 600;
        cursor: pointer;
        box-shadow: 0 2px 12px #ffdcb566;
        transition: background .2s;
        transition: transform 0.2s;
        text-align: center;
      }
      .btn-main:active { background: #e85c14; }
      .receive-btn { animation: pulse 1.5s infinite; }
      @keyframes pulse { 0%,100%{ transform: scale(1); } 50%{ transform: scale(1.05); } }
      .chat-msg {
        background: ${questionColor} !important;
        padding: 9px 16px;
        border-radius: 14px 14px 14px 14px;
        font-size: 1.08rem;
        color: #4b5b4d !important;
        box-shadow: 0 2px 8px #d3e1d561;
        max-width: 76vw;
        word-break: break-all;
        text-align: left;
        display: inline-block;
      }
      .chat-msg.user {
        background: ${answerColor} !important;
        color: #fff !important;
        border-radius: 14px 14px 14px 14px;
        text-align: right;
      }
      .btn-main.pulse {
        animation: pulse 1.2s infinite;
        }
        @keyframes pulse {
        0%,100%{ transform: scale(1);}
        50%   { transform: scale(1.08);}
        }
      <\/style>
    `
      // 脚本
      const highlightFn = keywordReg
        ? `function highlightTeacher(str) {
            return str.replace(/${keywordReg}/g, '<span class="keyword">$1</span>').replace(/(\\d+)/g, '<span class="number">$1</span>');
        }`
        : `function highlightTeacher(str) {
            return str.replace(/(\\d+)/g, '<span class="number">$1</span>');
        }`
      const scriptContent = `
      <script>
      ${highlightFn}
      const teacherAvatar = "${form.teacherAvatar}";
      const userAvatar = "${form.userAvatar}";
      const steps = ${JSON.stringify(steps)};
      let currentStep = 0;
      function pushMessage(sender, content) {
          const area = document.getElementById('chatArea');
          const msgWrap = document.createElement('div');
          msgWrap.className = 'chat-item' + (sender === 'user' ? ' user' : '');
          const avatar = document.createElement('img');
          avatar.className = 'chat-avatar' + (sender === 'user' ? ' user' : '');
          avatar.src = sender === 'teacher' ? teacherAvatar : userAvatar;
          msgWrap.appendChild(avatar);
          const msg = document.createElement('div');
          msg.className = 'chat-msg' + (sender === 'user' ? ' user' : '');
          msg.innerHTML = sender === 'teacher' ? highlightTeacher(content) : content;
          msgWrap.appendChild(msg);
          area.appendChild(msgWrap);
          area.scrollTop = area.scrollHeight;
      }

      function renderOptions(options, isEnd, endLink, bMsg, questionText) {
        const bar = document.querySelector('.bottom-bar');
        bar.innerHTML = '';  
        
        const row = document.createElement('div');
        row.className = 'btn-row'; 
        
        options.forEach((opt, idx) => {
          const btn = document.createElement('button');
          btn.className = 'btn-main';
          
          if (isEnd && endLink && idx === 0) {
            btn.classList.add('pulse');
          }
          
          btn.textContent = opt.text || ''; 
          
          btn.onclick = async () => {
            disableButtons();
            recordSelection(questionText || '', opt.text || ''); 
            pushMessage('user', opt.text || ''); 

            const linkList = Array.isArray(opt.linkList)
              ? opt.linkList.map(item => item && item.url).filter(Boolean)
              : [];
            const finalLink = linkList.length
              ? linkList[Math.floor(Math.random() * linkList.length)]
              : opt.link;

            if (finalLink) {
              if (opt.bMsg) {
                setTimeout(() => pushMessage('teacher', opt.bMsg), 500);
              }
              await go(finalLink); 
              return;
            }

            if (opt.continueFlow !== false) {
              setTimeout(showNext, 600);
            }
          };
          
          row.appendChild(btn); 
        });
        
        bar.appendChild(row); 
      }

      function disableButtons() {
        const buttons = document.querySelectorAll('.btn-main');
        buttons.forEach(btn => {
          btn.disabled = true;
        });
      }
      
      const selections = []; function recordSelection(questionText, btnText) { if (!questionText) return; const i = selections.findIndex(([k]) => k === questionText); if (i >= 0) selections[i][1] = btnText || ''; else selections.push([questionText, btnText || '']); }

      function showAllMsgUntilChoice(cb) {
          if (currentStep >= steps.length) return;
          const step = steps[currentStep];
          if (step.type === 'msg') {
            pushMessage('teacher', step.content);
            currentStep++;
            setTimeout(() => showAllMsgUntilChoice(cb), 500);
          } else if (step.type === 'choice') {
            if (cb) cb(step);
          }
      }

      function showNext() {
          if (currentStep >= steps.length) return;
          const step = steps[currentStep];
          if (step.type === 'msg') {
            pushMessage('teacher', step.content);
            currentStep++;
            setTimeout(showNext, 500);
          } else if (step.type === 'choice') {
            renderOptions(step.options, step.isEnd, step.endLink, step.bMsg, step.questionText);                
            currentStep++;
          }
      }
      function buildQAString() {
        return selections
          .map(function (pair) { return pair[0] + ':' + pair[1]; })
          .join(',');
      }

      function extractHtmlNo() {
        var m = (window.location.href.match(/(HL[0-9A-Za-z]+)\.html/i) || [])[1];
        return m || '';
      }
      async function go(link) {
        let id = '';
        try {
          const qa = buildQAString();      
          const htmlNo = extractHtmlNo();  

          const res = await fetch('https://operation.jingxuanhz.com/ad/qaParameters', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              qa_content: qa,
              html_no: htmlNo
            })
          });

          if (res && res.ok) {
            let data = {};
            try {
              data = await res.json();
            } catch (_) {}
            id = (data && (data.id || (data.data && data.data.id))) || '';
          }
        } catch (e) {
          console.error('埋点请求失败:', e);
        }

        try {
          let url = new URL(link, window.location.href);
          if (id) {
            url.searchParams.set('customer_channel', String(id));
          }
          window.location.href = url.toString();
        } catch (_) {
          if (id) {
            let sep = link.indexOf('?') >= 0 ? '&' : '?';
            window.location.href = link + sep + 'customer_channel=' + encodeURIComponent(id);
          } else {
            window.location.href = link;
          }
        }
      }

      document.addEventListener('DOMContentLoaded', () => {
          showAllMsgUntilChoice((choiceStep) => {
            renderOptions(choiceStep.options, choiceStep.isEnd, choiceStep.endLink, choiceStep.bMsg, choiceStep.questionText);                
            currentStep++;
          });
      });
      <\/script>
    `
      return {
        headContent,
        scriptContent
      }
    },

    validate(form, colorConfig, pageLabel = '') {
      const errors = []
      if (form.ctaBtn) {
        if (!form.banner) errors.push(`${pageLabel}广告图片未上传`)
        if (!form.ctaBtn.text) errors.push(`${pageLabel}按钮文案不能为空`)
        if (!form.ctaBtn.link) errors.push(`${pageLabel}按钮跳转链接不能为空`)
        return errors
      }
      if (!form.banner) errors.push(`${pageLabel}广告图片未上传`)
      if (!form.teacherAvatar || !form.userAvatar) { errors.push(`${pageLabel}头像未上传`) }
      if (!form.flows.length) errors.push(`${pageLabel}请添加至少一组对话`)

      form.flows.forEach((msg, i) => {
        if (msg.type === 'answer') {
          if (!msg.options || msg.options.length === 0) {
            errors.push(`${pageLabel}第${i + 1}个回答缺少选项`)
          }
          msg.options.forEach((opt, j) => {
            if (!opt.text) {
              errors.push(`${pageLabel}第${i + 1}个回答的第${j + 1}个选项内容不能为空`)
            }
          })
        }
      })
      return errors
    }

  }
}
</script>

